export default {
    name: "PlatformCustomerServicePrintManage",
    mounted: function () {
        this.init();
    },
    data() {
        return {
            searchForm: {
                // 出单公司
                sendCompanyName: null,
                // 收单公司
                receiveCompanyName: null,
                // 打印状态
                printStatus: null,
                // 申请时间
                applyTime: null,
                // 初审时间
                firstAuditTime: null,
                // 终审时间
                fianlAuditTime: null,
                printUserName: null,
                // // 申请人
                // applyName: null,
                // // 初审人
                // firstAuditName: null,
                // // 终审人
                // fianlAuditName: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0,
            loading: null,
            dialogVisible: false,
            dialogDownVisible: false,
            doApplyResetFlag: false,
            previousPrintFlag: true
        }
    },
    methods: {
        init() {
            let conditionParam = this.$routerUtil.getParam();
            if (conditionParam && conditionParam.searchForm) {
                conditionParam = conditionParam.searchForm;
            }
            console.log(conditionParam);
            this.$routerUtil.clearParam();
            if (conditionParam) {
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
            }
        },
        handleSizeChange(val) {
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val) {
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        rowClick(row) {
            this.$refs.table.toggleRowSelection(row);
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset() {
            this.$refs.searchForm.resetFields();
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            // 初审时间
            if (this.searchForm.firstAuditTime) {
                param.firstAuditUserDayBeginTime = this.searchForm.firstAuditTime[0];
                param.firstAuditUserDayEndTime = this.searchForm.firstAuditTime[1];
                delete param.firstAuditTime;
            }
            // 初审时间
            if (this.searchForm.fianlAuditTime) {
                param.finalAuditUserDayBeginTime = this.searchForm.fianlAuditTime[0];
                param.finalAuditUserDayEndTime = this.searchForm.fianlAuditTime[1];
                delete param.fianlAuditTime;
            }
            // 申请时间
            if (this.searchForm.applyTime) {
                param.applyTimeBeginTime = this.searchForm.applyTime[0];
                param.applyTimeEndTime = this.searchForm.applyTime[1];
                delete param.applyTime;
            }
            // 查询打印申请终审通过的 和 已打印的
            param.isPrintStatusList = 1;
            this.$axios.get('/api//prints/printManage', { params: param }).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doPostaged() {
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            this.$router.push('PostagedInfo');
            this.$routerUtil.setParam(conditionData);
        },
        doApplyReset() {
            const row = this.getSelectedRow();
            if (row) {
                const conditionData = new Object();
                conditionData.searchForm = this.searchForm;
                this.$router.push('ApplyReset');
                conditionData.row = row;
                this.$routerUtil.setParam(conditionData);
            }
        },
        previousPrint() {
            const row = this.getSelectedRow()
            if (row) {
                // 打印完成的打印申请不能在打印
                if (row.printStatus === 5) {
                    this.$message({
                        message: this.$t('p_custSvcPrintManage.message.isAlreadyPrint'),
                        type: 'warning',
                        center: true
                    });
                    return;
                } else {
                    this.dialogVisible = true;
                }
            }
        },
        previousDownLoad() {
            const row = this.getSelectedRow()
            if (row) {
                // 打印完成的打印申请不能在打印
                if (row.printStatus === 5) {
                    this.$message({
                        message: this.$t('p_custSvcPrintManage.message.isAlreadyPrint'),
                        type: 'warning',
                        center: true
                    });
                    return;
                } else {
                    this.dialogDownVisible = true;
                }
            }
        },
        sendMailThenPrint() {
            this.doPrint(true);
        },
        notSendMailThenPrint() {
            this.doPrint(false);
        },
        doPrint(isSendMail) {
            this.dialogVisible = false;
            const row = this.getSelectedRow();
            if (row) {
                // // 打印完成的打印申请不能在打印
                // if (row.printStatus === 5) {
                //     this.$message({
                //         message: this.$t('p_custSvcPrintManage.message.isAlreadyPrint'),
                //         type: 'warning',
                //         center: true
                //     });
                //     return ;
                // }
                const param = {};
                param.id = row.id;
                param.version = row.version;
                param.blId = row.blId;

                this.loading = this.$loading({
                    lock: true,
                    text: this.$t('common.message.printing'),
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.post('/api/customerCompay/printing', param).then(response => {
                    let type = 'error';
                    if (response.data.status === '1') {
                        type = 'success';
                        if (isSendMail) {
                            this.$axios.post('/api/customerCompay/sendmail', param);
                        }
                        // call seabert
                        this.callPrint(response.data.resultData);
                        return;
                    }
                    this.loading.close();
                    this.$message({
                        message: this.$t(response.data.message),
                        type: type,
                        center: true
                    });
                }).catch(e => {
                    console.log(e);
                    this.loading.close();
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                });
            }
        },
        confirmDownLoad() {
            //const row = this.getSelectedRow()
            //const billOfLadingBlNo = row.blNo
            this.doDownLoad(true);
        },
        /* notSendMailThenDownLoad() {
            this.doDownLoad(false);
        }, */
        doDownLoad() {
            this.dialogDownVisible = false;
            const row = this.getSelectedRow();
            if (row) {
                const param = {};
                param.id = row.id;
                param.version = row.version;
                param.blId = row.blId;

                this.loading = this.$loading({
                    lock: true,
                    text: this.$t('common.message.download'),
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.post('/api/customerCompay/download', param).then(response => {
                    let type = 'error';
                    if (response.data.status === '1') {
                        type = 'success';
                        /* if (isSendMail) {
                            this.$axios.post('/api/customerCompay/sendmail', param);
                        } */
                        //获取要下载的文件地址名称
                        //let downLoadFile = response.data.resultData;
                        //this.doUpdatePdf(downLoadFile, billOfLadingBlNo);
                    }
                    this.loading.close();
                    this.$message({
                        message: this.$t(response.data.message),
                        type: type,
                        center: true
                    });
                }).catch(e => {
                    console.log(e);
                    this.loading.close();
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                });
            }
        },
        doUpdatePdf(downLoadFile, billOfLadingBlNo) {
            const param = {};
            param.downLoadFile = downLoadFile;
            this.$axios.post('/api/customerCompay/downloadPdf', param, { responseType: 'arraybuffer' }).then(response => {

                const blob = new Blob([response.data], { type: 'application/pdf;charset-UTF-8' }) // 构造一个blob对象来处理数据，并设置文件类型
                if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
                    navigator.msSaveBlob(blob, "ydMerge.pdf")
                } else {
                    const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
                    const a = document.createElement('a') //创建a标签
                    a.style.display = 'none'
                    a.href = href // 指定下载链接
                    //a.download = this.filename //指定下载文件名
                    a.download = billOfLadingBlNo + ".pdf"
                    a.click() //触发下载
                    URL.revokeObjectURL(a.href) //释放URL对象
                }

            }).catch(e => {
                console.log(e);
                this.loading.close();
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });

        },
        getSelectedRow() {
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        callPrint(printInfo) {
            // const printDelaySecMill = 8000;
            const printDelaySecMill = 1000;
            // let index = 0
            // let item = printInfo[0]
            printInfo.forEach((item, index) => {
                setTimeout(() => {
                    let xmlhttp;
                    if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
                        xmlhttp = new XMLHttpRequest();
                    } else {// code for IE6, IE5
                        // eslint-disable-next-line no-undef
                        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                    }
                    xmlhttp.open("POST", "http://127.0.0.1:9999/seabert", false);
                    xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    xmlhttp.send("json=" + item.init);
                    xmlhttp.open("POST", "http://127.0.0.1:9999/seabert", false);
                    xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    xmlhttp.send("json=" + item.print);
                    if (index === printInfo.length - 1) {
                        this.loading.close();
                        this.$message({
                            message: this.$t('SM-101'),
                            type: 'success',
                            center: true
                        });
                    }
                }, index * printDelaySecMill);
            });
        }
    }
}
